// components

// react
import { useEffect, useState } from 'react';
import { BeatLoader } from 'react-spinners';

// kendo

// css
import "./help_mobile.css";
import styles from "./help_mobile.module.css";

// services

function HelpMobile({conn}) {

  const [loading, setLoading] = useState(false);

  return (
    <>
      <div className="pageContent_m">
        <div className="sub_01">
          <section className="sub_container_01">
            <p className="txt_box_01"><img src="/images/mobile/normal.png" alt="정상" />&nbsp;정상 : 정상적으로 데이터 수집이 되는 상태</p>
            <p className="txt_box_02"><img src="/images/mobile/warn.png" alt="경고" />&nbsp;경고 : 정상 데이터 수집되며 4시간 이상 자리비움 지속시
              (온도 40℃ 이상 4시간 지속 포함)</p>
            <p className="txt_box_03"><img src="/images/mobile/danger.png" alt="위험" />&nbsp;위험 : 정상 데이터 수집되며 24시간 이상 자리비움 지속 및 긴급버튼 신호 수신시
              (온도 40℃ 이상 24시간 이상 지속 포함)</p>
            <p className="txt_box_04"><img src="/images/mobile/off.png" alt="미작동" />&nbsp;미작동 : 1시간 이상 데이터 미수집 상태 지속시</p>
          </section>
      
          <section className="sub_container_02">
            <div className="txt_box_05">
              <div className="left_box"><img src="/images/mobile/high_activity.png" alt="고활동표시" /><span>고활동</span></div>
              <div className={styles.helpTxtDiv}>
              <span className={styles.helpTxtLine}> 고활동 : 30분 이상, 움직임 30 이상 측정</span>
              <span className={styles.helpTxtLine3}>* 3차장비 : 움직임이 존재하고, 속도 2,000 이상으로 측정되는 경우</span>
              </div>
            </div>
            <div className="txt_box_05">
              <div className="left_box"><img src="/images/mobile/low_activity.png" alt="저활동표시" /><span>저활동</span></div>
              <div className={styles.helpTxtDiv}>
                <span className={styles.helpTxtLine}> 저활동 : 30분 미만, 움직임 30 이상 측정</span>
                <span className={styles.helpTxtLine3}>* 3차장비 : 움직임이 존재하고, 속도 2,000 미만으로 측정되는 경우 또는 움직임이 존재하지 않고, 속도가 존재하는 경우</span>
              </div>
            </div>
            <div className="txt_box_05">
              <div className="left_box"><img src="/images/mobile/meal.png" alt="식사중표시" /><span>식사중</span></div>
              <div className={styles.helpTxtDiv}>
                <span className={styles.helpTxtLine}>
                  식사 : 움직임 50 이상, CO<small>2</small> 1,500 이상, 조도 10 이상으로 측정
                </span>
                <span className={styles.helpTxtLine3}>
                  * 3차장비 : 움직임이 존재하고, CO<small>2</small> 600 이상, 조도 10 이상으로 측정
                </span>
              </div>
            </div>
            <div className="txt_box_05">
              <div className="left_box"><img src="/images/mobile/out.png" alt="자리비움표시" /><span>자리비움</span></div>
              <div className={styles.helpTxtDiv}>
                <span className={styles.helpTxtLine}>자리비움 : 움직임 30 미만으로 측정</span>
                <span className={styles.helpTxtLine3}>* 3차장비 : 움직임이 존재하지 않고, 속도 0 으로 측정되는 경우</span>
              </div>
            </div>
            <div className="txt_box_05">
              <div className="left_box"><img src="/images/mobile/sleep.png" alt="수면중표시" /><span>수면중</span></div>
              <div className={styles.helpTxtDiv}>
              <span className={styles.helpTxtLine}>수면 : 움직임이 50 이하, 조도 10 이하로 측정되는 경우</span>
              <span className={styles.helpTxtLine3}>* 3차장비 : 움직임이 존재하지 않고, 속도 0, 조도 10 이하로 측정되는 경우</span>
                </div>
            </div>
            <div className="txt_box_05">
              <div className="left_box"><img src="/images/mobile/inoperative.png" alt="미작동표시" /><span>미작동</span></div>
              <div className="right_box">데이터 수집이 되지 않을 경우</div>
            </div>
          </section>
        </div>
      </div>
      {loading && (
        <p
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
          }}>
          <BeatLoader loading={true} size={18} color="#5e9dd4" />
        </p>
      )}
    </>
  );
}

export default HelpMobile;
